module.exports = __webpack_public_path__ + "img/core-advantages-4.967f6811.svg";